import * as E from 'fp-ts/lib/Either';
import {pipe} from 'fp-ts/lib/pipeable';
import React from 'react';
import {useSelector} from 'react-redux';
import {Redirect, Route} from 'react-router-dom';
import Loading from 'Shared/components/Loading';
import {Scope} from 'Shared/constants/Scope';
import {selectUserScopesEither} from 'Users/selectors/userProfileSelectors';
import CustomerSupport from './components/CustomerSupport';

const ROOT_URI = '/customerSupport';
export const CustomerSupportRouteConstants = {
  CUSTOMER_SUPPORT: `${ROOT_URI}`,
};

const CustomerSupportRoutes = () => {
  const currentScopesEither = useSelector(selectUserScopesEither);

  const renderCustomerSupportRoute = (currentScopes: Scope[]) => {
    const hasSearchCustomerSupportScope = currentScopes.includes(Scope.AgentSearchCustomerSupport);
    const hasAccessToCustomerSupport = hasSearchCustomerSupportScope;

    return hasAccessToCustomerSupport ? (
      <Route exact path={CustomerSupportRouteConstants.CUSTOMER_SUPPORT} render={() => <CustomerSupport />} />
    ) : (
      <Redirect to={'/unauthorized'} />
    );
  };

  return (
    <Route
      path={ROOT_URI}
      render={() =>
        pipe(
          currentScopesEither,
          E.fold(() => <Loading />, renderCustomerSupportRoute)
        )
      }
    />
  );
};

export default CustomerSupportRoutes;
